import type { Analytics } from "@models/analytics.model";
import LineChart from "./LineChart";

export default function ListSize({ analytics }: { analytics: Analytics }) {
    const rows = analytics.charts?.["list-count-wow"] ?? [];
    return <LineChart title="List Size Over Time" rows={rows} valueKey="list_size" seriesName="List Size" curve="straight" />;
}
